module.exports = __webpack_public_path__ + "tk.595812eb.svg";